// src/components/layout/RouteFallback.jsx
// Suspense fallbacks for lazily loaded routes. Visuals copied from the
// existing precedents so a chunk load looks like any other loading state.

// Inside the app shell (sidebar/header stay mounted) — PermissionGuard style
export function RouteFallback() {
  return (
    <div className="flex items-center justify-center min-h-[200px]">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
    </div>
  );
}

// Before the shell mounts (public routes, cold deep links) — ProtectedRoute style
export function FullPageFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}
